import { render } from "./Top3Slide.vue?vue&type=template&id=7059e25f&scoped=true"
import script from "./Top3Slide.vue?vue&type=script&lang=js"
export * from "./Top3Slide.vue?vue&type=script&lang=js"

import "./Top3Slide.vue?vue&type=style&index=0&id=7059e25f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7059e25f"]])

export default __exports__